import { RepositorioBase } from "@/http"
import {
  GerarArquivoDePagamento,
  GerarRelatorioAtividadesParams,
  RespostaAoBaixarRelatorio,
} from "./relatorios.modelo"

export class RelatoriosRepositorio extends RepositorioBase {
  public gerarRelatorioDeAtividades = (
    params?: GerarRelatorioAtividadesParams
  ): Promise<{ resultados: string[] }> =>
    this.instance.post("/api/relatorios/gerar-atividades-realizadas", params)

  public baixarRelatorio = async (urlArquivo?: string): Promise<RespostaAoBaixarRelatorio> => {
    const resposta = await this.instance.get("/api/relatorios/baixar/" + urlArquivo, {
      responseType: "blob",
    })

    return {
      blob: resposta,
      nomeArquivo: this.cabecalhos['x-nome-arquivo']
    }
  }

  public baixarArquivoDePagamento = (
    dados?: GerarArquivoDePagamento
  ): Promise<string> =>
    this.instance.post("/api/relatorios/arquivos-de-pagamento", dados, {
      responseType: "text",
    })
}
